import React, { ComponentProps } from "react";

import BigContent from "veneer/BigContent";
import VeneerGrid from "veneer/Grid";
import Stack from "veneer/Stack";
import styled from "veneer/styled";

import { useAppSelector } from "cortex/ui/src/hooks";
import {
  type LastSeenDeviceCounts,
  lastSeenDeviceCountsSelector,
} from "cortex/ui/src/redux-store/last-seen-devices/selectors";
import { Panel } from "cortex/ui/src/view/layout";

import DeviceMetricsPanel from "./DeviceMetricsPanel";
import LastSeenStatusPanel, {
  type LastSeenStatusPanelProps,
} from "./LastSeenStatusPanel";

export interface DeviceStatsProps {
  counts?: LastSeenDeviceCounts;
  deviceMetricsCounts?: ComponentProps<
    typeof DeviceMetricsPanel
  >["metricsTotal"];
  onDeviceMetricClick?: ComponentProps<
    typeof DeviceMetricsPanel
  >["onMetricClick"];
  onNeverConnectedClick?: ComponentProps<
    typeof DeviceMetricsPanel
  >["onNeverConnectedClick"];
  onLastSeenTierClick?: LastSeenStatusPanelProps["onTierClick"];
}

const Grid = styled(VeneerGrid)({
  display: "flex",
});

export default function DeviceStats({
  counts,
  deviceMetricsCounts,
  onDeviceMetricClick,
  onNeverConnectedClick,
  onLastSeenTierClick,
}: DeviceStatsProps) {
  const selectorCounts = useAppSelector(lastSeenDeviceCountsSelector);
  const lastSeenDeviceCounts = counts ?? selectorCounts;

  return (
    <Grid alignItems="stretch" columns={12} container spacing={2}>
      <Grid item xl={4} xs={5}>
        <LastSeenStatusPanel
          counts={lastSeenDeviceCounts}
          onTierClick={onLastSeenTierClick}
        />
      </Grid>
      <Grid item xs={2}>
        <Panel mb={0}>
          <Stack
            alignItems="center"
            flex={1}
            height="100%"
            justifyContent="center"
          >
            <BigContent label="Total Devices">
              {lastSeenDeviceCounts.totalDevices.toLocaleString()}
            </BigContent>
          </Stack>
        </Panel>
      </Grid>
      <Grid item xs={3}>
        <DeviceMetricsPanel
          metricsTotal={deviceMetricsCounts}
          onMetricClick={onDeviceMetricClick}
          onNeverConnectedClick={onNeverConnectedClick}
        />
      </Grid>
    </Grid>
  );
}
